export const environment = {
    production: false,
    serverUrl: 'https://xotgodxv28.execute-api.us-east-2.amazonaws.com/dev',
    tokenEndpoint: 'https://auth.fit.bdataredthread.com/oauth2/token',
    redirectUrl: 'https://fit.bdataredthread.com',
    managedLoginUrl: 'https://auth.fit.bdataredthread.com/login',
    bucket: 'fitoidc-prod-upload',
    userPool: {
        UserPoolId: 'us-east-2_Hgp96q9rP',
        ClientId: '3muofvntrtvqtug44ui0d4qqff',
        region: 'us-east-2'
    },
    identityPoolId: 'us-east-2:6fcb0f3e-0ba7-487f-84b8-622416b47919',

    defaultRegion: 'us-east-2',
    cognito: {
        identityPoolId: 'us-east-2:6fcb0f3e-0ba7-487f-84b8-622416b47919', // REQUIRED - Amazon Cognito Identity Pool ID
        region: 'us-east-2', // REQUIRED - Amazon Cognito Region
        userPoolId: 'us-east-2_Hgp96q9rP', // OPTIONAL - Amazon Cognito User Pool ID
        userPoolWebClientId: '3muofvntrtvqtug44ui0d4qqff', // OPTIONAL - Amazon Cognito Web Client ID
    },
    Storage: {
        AWSS3: {
            bucket: 'fitoidc-prod-upload', // REQUIRED -  Amazon S3 bucket
            region: 'us-east-2', // OPTIONAL -  Amazon service region
        }
    }
};

const awsconfig = {
  Auth: {
    Cognito: {
      userPoolClientId: '3muofvntrtvqtug44ui0d4qqff',
      userPoolId: 'us-east-2_Hgp96q9rP',
      identityPoolId: 'us-east-2:6fcb0f3e-0ba7-487f-84b8-622416b47919'
    }
  },
  Storage: {
    S3: {
      bucket: 'fitoidc-prod-upload',
      region: 'us-east-2'
    }
  }
};
export default awsconfig;
